import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { createAction, props, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { DataService } from '../../form-core/data/data.service';
import { ServiceStepID, StepID } from '../../form-json.types';
import { State } from '../../store';
import { selectStepsValidity } from '../../store/step-validity';

export const activateFail = createAction('[Activate Guard] activate fail', props<{redirectTo: StepID | ServiceStepID}>())
export const activateSuccess = createAction('[Activate Guard] activate success', props<{step: string}>())

@Injectable({
  providedIn: 'root'
})
export class ActivateGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const activateStep = route.paramMap.get('id') as string
    const steps = this.data.getSteps()
    const activateIndex = steps.findIndex(step => step.id === activateStep)
    const pendingForCheck = steps.slice(0, activateIndex)
    if (activateIndex === 0) return true
    return this.store.pipe(
      select(selectStepsValidity),
      map(stepsValidity => {
        let result: boolean | UrlTree = true
        for (let step of pendingForCheck) {
          if (stepsValidity[step.id] !== 'VALID') {
            result = this.router.parseUrl(`/step/${step.id}`)
            this.store.dispatch(activateFail({redirectTo: step}))
            break
          }
        }
        result === true && this.store.dispatch(activateSuccess({step: activateStep}))
        return result
      }),
      first()
    )
  }

  constructor(private data: DataService, private store: Store<State>, private router: Router) { }

}
